var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"title":"视频下载","visible":_vm.visible,"confirm-loading":_vm.confirmLoading},on:{"cancel":_vm.handleCancel,"ok":_vm.handleConfirm}},[_c('p',[_vm._v("是否下载视频？")]),_c('p',[_vm._v("备注：视频下载后，使用要注意版权问题！")])])}
var staticRenderFns = []

export { render, staticRenderFns }